import '../globals';
import { Dropdown } from "bootstrap";

/**
 * Initialize Select fields
 */
(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        // hide dropdown if another place is clicked
        document.addEventListener('click', (e) => {
            const target = e.target.closest('.bootstrap-select');

            const selectDropdowns = document.querySelectorAll('.bootstrap-select.show');
            selectDropdowns.forEach((dropdownEl) => {
                if (dropdownEl !== target) {
                    const dropdown = Dropdown.getOrCreateInstance(dropdownEl);

                    dropdown.hide();
                }
            })
        }, {passive: true});
    });
})(window.PageLoadedQueue);

const originalSelectpicker = $.fn.selectpicker;

$.fn.selectpicker = function(options, customCallback) {
    const result = originalSelectpicker.apply(this, [options]);

    // bootstrap-select only works with DropdownHelper
    document.dispatchEvent(new Event('plandent.reinit.bootstrapDropdown'));
    return result;
};
